import { GET_PROTOCOL_PROFILE, RESET_PROTOCOL_PROFILE } from "./action-types";

import { initialState } from "./initialState";

export const protocolProfileReducer = (
  state = initialState,
  action: any
): any => {
  switch (action.type) {
    case GET_PROTOCOL_PROFILE:
      return {
        ...action.payload,
        isLoading: false,
      };
    case RESET_PROTOCOL_PROFILE:
      return initialState;
    default:
      return state;
  }
};
